<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <image-list
    :entity-name="$t('bannerImg')"
    :model="model"
    icon="mdi-calendar-today"
  />
</template>

<script>

  import { IkDataTable } from 'metaflow-js'
  import BannerImage from '../../../../model/restaurant/BannerImage'
  import ImageList from '@/composable/ImageList'

  export default {
    components: {
      ImageList,
      IkDataTable,
    },
    data: function () {
      return ({
        model: BannerImage,
      })
    },
  }
</script>
